module.exports = __webpack_public_path__ + "img/DasDuell.402df53b.svg";